export default __webpack_public_path__ + "assets/profeature-batch-edit.de890b97d955d0b1fc5f272aa1e6f41a.jpg";